import { useState } from "react";
import UDocViewer from "./UDocViewer";

const DocViewer = ({ src }) => {
  const [useFallback, setUseFallback] = useState(false);

  if (useFallback) {
    return (
      <iframe
        title="Document Viewer"
        src={`https://view.officeapps.live.com/op/embed.aspx?src=${src}`}
        style={{ width: "100%", height: "90vh" }}
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
      ></iframe>
    );
  }

  return (
    <div style={{ width: "100%", height: "90vh" }}>
      <UDocViewer src={src} onError={() => setUseFallback(true)} />
    </div>
  );
};

export default DocViewer;
